import React from "react";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/Headline";
import StoryMetaData from "../StoryMetaData";
import { getExcerpt, getHeadline } from "../../utils/utils";

import "./customStoryCard3.m.css";

const CustomStoryCard3 = ({
  story,
  isTag,
  isExcerpt = false,
  isWidget = false,
  updatedFont,
  publisherLang,
  src,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => {
  const { subheadline } = story;
  const storyHeadline = getHeadline(story);
  const excerpt = getExcerpt(story);
  const headlineStyle = updatedFont ? `${publisherLang}-story-headline` : "";
  const subHeadlineStyle = updatedFont ? `${publisherLang}-sub-headline` : "";
  const excerptStyle = updatedFont ? `${publisherLang}-excerpt` : "";

  return (
    <div styleName={`base`} className={`custom-story-card-3 ${isWidget ? "with-widget" : ""}`}>
      <div>
        {subheadline && (
          <Link href={story.url}>
            <Headline
              text={subheadline}
              headerLevel={3}
              headlineType={6}
              className="section-name"
              styleName={subHeadlineStyle}
            />
          </Link>
        )}
        <Link
          href={story.url}
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label={datatrackinglabel}
        >
          <Headline
            text={storyHeadline}
            headerLevel={2}
            headlineType={4}
            className="story-headline"
            styleName={headlineStyle}
          />
        </Link>
        {isExcerpt && excerpt && (
          <Link
            href={story.url}
            data-tracking-category={datatrackingcategory}
            data-tracking-action={datatrackingaction}
            data-tracking-label={datatrackinglabel}
          >
            <Headline
              text={excerpt}
              headerLevel={3}
              headlineType={6}
              className="sub-headline"
              styleName={excerptStyle}
              dangerouslySet={true}
            />
          </Link>
        )}
        <StoryMetaData story={story} isTag={isTag} updatedFont={updatedFont} publisherLang={publisherLang} src={src} />
      </div>
    </div>
  );
};

CustomStoryCard3.propTypes = {
  story: object.isRequired,
  isTag: bool,
  isExcerpt: bool,
  isWidget: bool,
  updatedFont: bool,
  src: string,
  publisherLang: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default CustomStoryCard3;
